export default __webpack_public_path__ + "static/large-headings-dont-9ccc0d2b2277d5aec1a7e5e01b105f2a.png";